// extracted by mini-css-extract-plugin
export var providerCard = "interchange-module--providerCard--RjJyh";
export var providerLogo = "interchange-module--providerLogo--doQ+m";
export var root = "interchange-module--root--9xOPB";